import { useEffect, useState } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import api from "../../lib/api";

export const OpeningHoursSection = () => {
  const { t } = useLanguage();
  const [hours, setHours] = useState(null);

  useEffect(() => {
    api.get("/working-hours").then(({ data }) => setHours(data)).catch(() => setHours([]));
  }, []);

  return (
    <section data-testid="opening-hours-section" className="py-16 sm:py-20 px-4 sm:px-6 bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-2xl mx-auto">
        <h2 className="font-serif text-2xl sm:text-3xl text-white mb-8 tracking-tight text-center">{t("hours.title")}</h2>
        <div className="bg-[#141414] border border-white/5 rounded-xl divide-y divide-white/5">
          {hours && hours.map((h) => (
            <div key={h.weekday} data-testid={`hours-row-${h.weekday}`} className="flex items-center justify-between px-6 py-3.5">
              <span className="text-white/80 text-sm">{t(`hours.days.${h.weekday}`)}</span>
              <span className={`text-sm ${h.is_open ? "text-white" : "text-white/40"}`}>
                {h.is_open ? `${h.start_time} – ${h.end_time}` : t("hours.closed")}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
